// The `weather` field on each entry is only a fallback shown while
// MapboxIntro's live fetch (all locations' stations, via the backend) is in
// flight or unavailable — see MapboxIntro.jsx. It is not kept in sync with
// real conditions on purpose; don't rely on it for anything live.
export const TLT_LOCATIONS = [
  {
    id: 'tlt-islamabad',
    slug: 'f-11',
    name: 'TLT F-11',
    lat: 33.68456090528943,
    lng: 72.98796455767132,
    weather: { temperature: 16, humidity: 60, condition: 'Clear Skies', windSpeed: 7, icon: '☀️' }
  },
  {
    id: 'tlt-giga-mall',
    slug: 'giga-mall',
    name: 'TLT Giga Mall',
    lat: 33.52176705448803,
    lng: 73.1563285,
    weather: { temperature: 15, humidity: 65, condition: 'Partly Cloudy', windSpeed: 10, icon: '⛅' }
  },
  {
    id: 'tlt-multan',
    slug: 'multan',
    name: 'TLT Multan',
    lat: 30.29113511742204,
    lng: 71.5131295576713,
    weather: { temperature: 24, humidity: 45, condition: 'Sunny', windSpeed: 5, icon: '☀️' }
  },
  {
    id: 'tlt-gujranwala',
    slug: 'gujranwala',
    name: 'TLT Gujranwala',
    lat: 32.233113979780654,
    lng: 74.16707875767132,
    weather: { temperature: 18, humidity: 55, condition: 'Hazy', windSpeed: 8, icon: '🌤️' }
  },
  {
    id: 'tlt-lahore',
    slug: 'lahore',
    name: 'TLT Lahore',
    lat: 31.508762004785478,
    lng: 74.35063775767132,
    weather: { temperature: 20, humidity: 58, condition: 'Partly Cloudy', windSpeed: 12, icon: '⛅' }
  }
];

export function resolveTltLocation(value) {
  const normalized = String(value || '').trim().toLowerCase();
  if (!normalized) return TLT_LOCATIONS[0];

  return TLT_LOCATIONS.find((location) => {
    return [
      location.id,
      location.slug,
      location.name
    ].some((candidate) => String(candidate).toLowerCase() === normalized);
  }) || TLT_LOCATIONS.find((location) => {
    return normalized.includes(location.slug) || normalized.includes(location.name.toLowerCase());
  }) || TLT_LOCATIONS[0];
}
